import { render, staticRenderFns } from "./NavItemGroup.vue?vue&type=template&id=6cca0dfc&scoped=true&"
import script from "./NavItemGroup.vue?vue&type=script&lang=js&"
export * from "./NavItemGroup.vue?vue&type=script&lang=js&"
import style0 from "./NavItemGroup.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NavItemGroup.vue?vue&type=style&index=1&id=6cca0dfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cca0dfc",
  null
  
)

export default component.exports